import { render, staticRenderFns } from "./ClipImg.vue?vue&type=template&id=8332f280"
import script from "./ClipImg.vue?vue&type=script&lang=js"
export * from "./ClipImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports